import { N10, N40 } from '@trello/colors';
import { TextDefaultColor, IconDefaultColor } from '@trello/nachos/tokens';
import { SharedState, useSharedState } from '@trello/shared-state';

export const THEME_DARK = 'theme-dark';
export const THEME_LIGHT = 'theme-light';

interface ThemeVariables {
  theme: typeof THEME_DARK | typeof THEME_LIGHT;
  dynamicBackgroundColor: string;
  dynamicBackgroundColorTransparent?: string;
  dynamicIconColor: string;
  dynamicTextColor: string;
  dynamicTextColorTransparent: string;
}

// Use light theme as default fallback value.
export const lightTheme: ThemeVariables = {
  theme: THEME_LIGHT,
  dynamicBackgroundColor: N10,
  dynamicBackgroundColorTransparent: undefined,
  dynamicIconColor: IconDefaultColor,
  dynamicTextColor: TextDefaultColor,
  dynamicTextColorTransparent: N40,
};

const themeVariables = new SharedState<ThemeVariables>(lightTheme);

export const useThemeVariables = () => useSharedState(themeVariables);
